import axios from "axios";
import { API_BASE_URL } from "./axiosInstance";

// Dedicated instance for public, token-in-URL pages (e.g. the emailed
// external-approver timesheet link). Deliberately has NO interceptors —
// the shared `axiosInstance` logs the browser out on any 401, which would
// be wrong here: an expired/invalid approval-link token is an expected,
// unrelated-to-login error, not a reason to end a session that may belong
// to someone else entirely in this browser.
//
// Reuses axiosInstance's API_BASE_URL rather than hardcoding its own, so
// there's only one place to update the backend URL before each deploy.
export const publicAxiosInstance = axios.create({
    baseURL: API_BASE_URL,
});

export async function publicGetData(url) {
    const res = await publicAxiosInstance.get(url);
    return res.data;
}

export async function publicPostData(url, payload) {
    const res = await publicAxiosInstance.post(url, payload);
    return res.data;
}

export async function publicPutData(url, payload) {
    const res = await publicAxiosInstance.put(url, payload);
    return res.data;
}
